<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">   
      
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
            <el-form-item>
                <el-select v-model="query.refund_type" placeholder="请选择售后单类型" clearable filterable @change="query.ischange=true">
              	    <el-option v-for="item in ordertypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="query.order_status" placeholder="关联销售单状态" clearable filterable @change="query.ischange=true">
              	    <el-option v-for="item in returntypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="query.refund_status" placeholder="售后单状态" clearable filterable @change="query.ischange=true">
              	    <el-option v-for="item in orderstatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="query.inter_status" placeholder="小二介入状态" clearable filterable @change="query.ischange=true">
              	    <el-option v-for="item in intertypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="query.refund_reason_type" placeholder="退款原因" clearable filterable @change="query.ischange=true">
              	    <el-option v-for="item in refundreasontypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="query.refund_reason_type" placeholder="退款承担/抵扣状态" clearable filterable @change="query.ischange=true">
              	    
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="query.time_filter" placeholder="请选择查询时间类型" filterable @change="query.ischange=true">
              	    <el-option v-for="item in timetypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker	v-model="query.time" type="daterange" style="width:280px"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd" :unlink-panels="false" @change="query.ischange=true">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-input placeholder="请输入店铺名称" v-model="query.shop_name" @keyup.enter.native="getlists" clearable @change="query.ischange=true"/>
            </el-form-item>
            <el-form-item>
                <el-input placeholder="请输入商城订单编号" v-model="query.order_sn" @keyup.enter.native="getlists" clearable @change="query.ischange=true"/>
            </el-form-item>
            <el-form-item>
                <el-input placeholder="请输入售后单号" v-model="query.refund_sn" @keyup.enter.native="getlists" clearable @change="query.ischange=true"/>
            </el-form-item>
            <el-form-item>
                <el-input placeholder="请输入物流单号" v-model="query.shipping_sn" @keyup.enter.native="getlists" clearable @change="query.ischange=true"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getlists">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-setting" @click="settingaddresstobuyer">设置售后收货地址</el-button>
            </el-form-item>
            <!--
            <el-form-item>
              <el-button type="success" icon="el-icon-download" @click="getList">导出</el-button>
            </el-form-item>
            -->
            <el-form-item>
              <el-badge :value="refundtemps.length > 0 ? refundtemps.length : ''" class="item">
                <el-button type="warning" icon="el-icon-setting" @click="agreerecievemore(1)">批量同意退货</el-button>
              </el-badge>
            </el-form-item>
            <el-form-item>
              <el-badge :value="refundtemps.length > 0 ? refundtemps.length : ''" class="item">
                <el-button type="warning" icon="el-icon-setting" @click="gopaymore(1)">批量同意退款</el-button>
              </el-badge>
            </el-form-item>
            <el-form-item>
                <el-button type="" @click="clearrefundorder">清空选中售后单</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="exportdata">导出</el-button>
            </el-form-item>
        </el-form>

        <div class="backborder2" style="margin-top:10px">
            <el-table :data="lists" v-loading="query.loading" ref="goodsmultipleTable" @select="orderselect" @select-all="orderselectall">
                <el-table-column type="selection" width="60" align="center"></el-table-column>
                <el-table-column label="ID" min-width="90" align="left">
                    <template slot-scope="scope">
                        <div class="mall-order-sale-after-goods-isclose" v-if="scope.row.isclose==1">交易关闭</div>
                        <div style="font-size:13px">{{scope.row.id}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="售后订单信息" width="320" align="left">
                    <template slot-scope="scope">
                        <div class="mall-order-sale-after-ordernumbers">
                            <el-tooltip placement="top">
                            <div slot="content">{{scope.row.order_status==0 || scope.row.order_status==1 || scope.row.order_status==2 || scope.row.order_status==3 || scope.row.order_status==4 ? '发起售后时关联的商城订单未被买家签收' : '发起售后时关联的商城订单买家已签收'}}</div>
                            <div class="mall-order-sale-before-status">
                                {{scope.row.order_status==0 || scope.row.order_status==1 || scope.row.order_status==2 || scope.row.order_status==3 || scope.row.order_status==4 ? '售中' : '售后'}}
                            </div>
                            </el-tooltip>
                            <div class="mall-order-sale-after-orders">{{scope.row.order_sn}}</div>
                            <div class="mall-order-sale-after-status" style="margin-left:10px">
                                 <img src="../../assets/refund_balance.png" style="width:22px;height:22px;" />
                                 <img src="../../assets/refund_goods.png" v-if="scope.row.refundtype==2" style="width:22px;height:22px;" />
                            </div>
                        </div>
                        <div class="mall-order-sale-after-ordernumbers">
                            <div class="mall-order-sale-after-orders" style="font-size:12px">
                                <div v-if="scope.row.status==0">创建成功，等待审核</div>
                                <div v-if="scope.row.status==1">商家审核失败</div>
                                <div v-if="scope.row.status==2">商家审核成功</div>
                                <div v-if="scope.row.status==3">买家已发货，等待商家签收</div>
                                <div v-if="scope.row.status==4">商家拒绝签收</div>
                                <div v-if="scope.row.status==5">商家已签收，等待退款</div>
                                <div v-if="scope.row.status==6">商家已退款</div>
                                <div v-if="scope.row.status==7">买家撤销售后单</div>
                                <div v-if="scope.row.isinter==1">（买家申请平台介入）</div>
                                <div v-if="scope.row.isinter==2">（平台正在处理）</div>
                            </div>
                            <el-tooltip placement="top" :key="'showerror'+scope.row.id">
                                <div slot="content">{{scope.row.isshowerrormsg}}</div>
                                <div class="mall-order-sale-after-orders-error" v-if="scope.row.isshowerror==1" >?</div>
                            </el-tooltip>
                        </div>

                        <div style="float:left;width:100%" v-if="scope.row.timeout_msg!=''">
                            <div style="float:left;font-size:12px;margin-top:5px;line-height:15px;color:red;border-radius:15px;">{{scope.row.timeout}}{{scope.row.timeout_msg}}</div>
                        </div>

                    </template>
	            </el-table-column>
                <el-table-column label="商品信息" min-width="350" align="left">
                    <template slot-scope="scope">
                        <div class="mall-order-sale-after-goods-out">
                            <div class="mall-order-sale-after-goods-in">
                                <img :src="scope.row.refund_detail.thumb!='' ? scope.row.refund_detail.thumb : require('@/assets/default_img_mini.png')" />
                            </div>
                        </div>
                        <div class="mall-order-sale-after-goods-lists">
                            <div class="mall-order-sale-after-goods-name" v-if="scope.row.refund_detail.productid > 0">{{scope.row.refund_detail.productname}}</div>
                            <div class="mall-order-sale-after-goods-spec" v-if="scope.row.refund_detail.propertyid > 0">规格：{{scope.row.refund_detail.propertyname}}</div>
                            <div class="mall-order-sale-after-goods-spec"  v-if="scope.row.refund_detail.propertyid > 0">sku：{{scope.row.refund_detail.sku}}，品牌：{{scope.row.refund_detail.companyname}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="退货退款信息" width="200" align="center">
                    <template slot-scope="scope">
                        <div class="mall-order-sale-after-ordernumbers">
                            <em style="float:left;font-style:normal;font-size:13px;width:100%;text-align:center">申请退款金额：￥{{scope.row.refundprices}}</em>
                            <em style="float:left;font-style:normal;font-size:13px;width:100%;text-align:center" v-if="scope.row.refund_detail.numbers > 0">申请退货数量：{{scope.row.refund_detail.numbers}}</em>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="query.time_filter==1 ? '买家申请售后时间' : '最后修改时间' " width="170" align="center">
                    <template slot-scope="scope">
                        <div class="mall-order-sale-after-create-time" v-if="query.time_filter==1">{{scope.row.inputtime_desc}}</div>
                        <div class="mall-order-sale-after-create-time" v-if="query.time_filter==2">{{scope.row.updatetime_desc}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="买家退款 / 退货退款原因" width="200" align="center">
                    <template slot-scope="scope">
                        <div class="mall-order-sale-after-ordernumbers">
                            <div class="mall-order-sale-after-buyer-reason" style="color:#333;font-weight:bold;">（{{scope.row.reason_type}}）</div>
                            <div class="mall-order-sale-after-buyer-reason">{{scope.row.reason}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="关联订单信息" width="180" align="center">
                    <template slot-scope="scope">
                        <div class="mall-order-sale-after-ordernumbers" style="font-size:13px;text-align:center">
                            {{scope.row.ordernumber}}
                        </div>
                    </template>
	            </el-table-column>
                <el-table-column label="买家信息" width="200" align="center">
                    <template slot-scope="scope">
                        <div class="mall-order-sale-after-ordernumbers">
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center">{{scope.row.shopname}}</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center">（{{scope.row.shopphone}}）</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="关联订单当前状态" width="220" align="center">
                    <template slot-scope="scope">
                        <div class="mall-order-sale-after-ordernumbers">
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==0">待确认</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==1">已发货，待签收</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==2">已发货，待确认</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==3">已发货，待确认</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==4">已确认，待发货</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==5">客户已签收</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==6">客户申请退货</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==7">已退货</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==8">商家拒绝退货</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==9">买家取消</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==10">商家取消</div>
                            <div class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center" v-if="scope.row.order_status==11">已完成</div>

                            <div v-if="scope.row.order_logistics.logisticsid > 0" class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center">
                                <a class="mall-order-sale-after-log-main-content-shipping" @click="getshippingmsg(scope.row,1)">
                                （{{scope.row.order_logistics.logisticsname}}_{{scope.row.order_logistics.code}}）
                                </a>
                            </div>
                            <div v-if="scope.row.order_logistics_more == 1" class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center">
                                <a class="mall-order-sale-after-log-main-content-shipping" @click="getshippingmsg(scope.row,1)">
                                （更多）
                                </a>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="买家退货寄回物流信息" width="220" align="center">
                    <template slot-scope="scope">
                        <div class="mall-order-sale-after-ordernumbers" v-if="scope.row.refundtype==1">/</div>
                        <div class="mall-order-sale-after-ordernumbers" v-if="scope.row.refundtype==2">

                            <div v-if="scope.row.order_logistics_buyer.logisticsid > 0" class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center">
                                <a class="mall-order-sale-after-log-main-content-shipping" @click="getshippingmsg(scope.row,2)">
                                （{{scope.row.order_logistics_buyer.logisticsname}}_{{scope.row.order_logistics_buyer.code}}）
                                </a>
                            </div>
                            <div v-if="scope.row.order_logistics_buyer_more == 1" class="mall-order-sale-after-buyer" style="float:left;width:100%;text-align:center">
                                <a class="mall-order-sale-after-log-main-content-shipping" @click="getshippingmsg(scope.row,2)">
                                （更多）
                                </a>
                            </div>
                            
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250" align="center" fixed="right">
                    <template slot-scope="scope">

                        <!-- 仅退款 -->
                        <el-button type="primary" round size="mini" @click="getafterdetails(scope.row)" style="margin:5px 10px 5px 0">查看详情</el-button>
                        <el-button type="primary" round size="mini" @click="getafterlogs(scope.row)" style="margin:5px 10px 5px 0">操作记录</el-button>
                        <el-button type="warning" round size="mini" style="margin:5px 10px 5px 0" v-if="scope.row.isclose==0 && scope.row.status==0 && scope.row.refundtype==1" @click="gopay(scope.row,1)">同意退款</el-button>
                        <el-button type="" round size="mini" style="margin:5px 10px 5px 0" v-if="scope.row.isclose==0 && scope.row.status==0 && scope.row.refundtype==1" @click="nogopay(scope.row,2)">拒绝退款</el-button>
                        <el-button type="warning" round size="mini" style="margin:5px 10px 5px 0" v-if="scope.row.isclose==0 && scope.row.status==2 && scope.row.refundtype==1" @click="gopay(scope.row,1)">去退款</el-button>
                        
                        <!-- 退货退款 -->
                        <el-button type="warning" round size="mini" style="margin:5px 10px 5px 0" v-if="scope.row.isclose==0 && scope.row.status==0 && scope.row.refundtype==2" @click="agreerecieve(scope.row,1)">同意退货</el-button>
                        <el-button type="" round size="mini" style="margin:5px 10px 5px 0" v-if="scope.row.isclose==0 && scope.row.status==0 && scope.row.refundtype==2" @click="noagreerecieve(scope.row,2)">拒绝退货</el-button>
                        <el-button type="warning" round size="mini" style="margin:5px 10px 5px 0" v-if="scope.row.isclose==0 && scope.row.status==3 && scope.row.refundtype==2" @click="sendget(scope.row,1)">确认收货，并退款</el-button>
                        <el-button type="" round size="mini" style="margin:5px 10px 5px 0" v-if="scope.row.isclose==0 && scope.row.status==3 && scope.row.refundtype==2" @click="nosendget(scope.row,2)">拒绝收货</el-button>
                        <el-button type="warning" round size="mini" style="margin:5px 10px 5px 0" v-if="scope.row.isclose==0 && scope.row.status==5 && scope.row.refundtype==2" @click="gopay(scope.row,1)">去退款</el-button>

                    </template>
                </el-table-column>
            </el-table>

            <div class="block">
		      <!--分页begin-->
		      <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
		      	  :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="query.rows">
		      </el-pagination>
		      <!--分页end-->
	        </div>

        </div>


        <!-- 操作记录 -->
        <el-dialog title="操作记录" :visible.sync="logDialog" width="40%" top="5vh">
            <div class="mall-order-sale-after-log-out" v-loading="logloading">
                <div v-for="(item,index) in loginfos" v-if="loginfos.length > 0" :key="index" class="mall-order-sale-after-log-in" :style="item.isend==1 ? 'color:red;border-left:1px solid red' : ''">
                    <div class="mall-order-sale-after-log-in-label" :style="item.isend==1 ? 'background:red' : ''">
                        <div class="mall-order-sale-after-log-in-label-in" :style="item.isend==1 ? 'background:red' : ''"></div>
                    </div>
                    <div class="mall-order-sale-after-log-in-msg">{{item.msg}}（{{item.sysname}}）</div>
                    <div class="mall-order-sale-after-log-in-msg">{{item.time}}</div>
                </div>
                <div v-if="loginfos.length == 0"  style="display:flex;width:100%;height:100px;justify-content:center;align-items:center;">
                    <img src="../../assets/history_gray.png" style="width:30px;height:30px;display:inline-block" />
                    <div style="font-size:14px;margin-left:2%;color:#777777">暂无操作记录</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="logDialog=false">取 消</el-button>
            </div> 
        </el-dialog>

        <!-- 售后单详情 -->
        <el-dialog title="售后订单详情" :visible.sync="infosDialog" width="60%" top="5vh" :closed="closedetails">
            <div class="mall-order-sale-after-log-detail" v-loading="infoloading">
                <div class="mall-order-sale-after-log-main" style="position:relative;">
                    <div class="mall-order-sale-after-log-main-title">售后类型</div>
                    <div class="mall-order-sale-after-log-main-content">
                        <div class="mall-order-sale-after-log-main-content-status">{{infosdetail.refundtype}}（{{infosdetail.status}} {{infosdetail.isinter!='' ? '，'+infosdetail.isinter : '' }}）</div>
                        <div class="mall-order-sale-after-log-main-content-warning" v-if="infosdetail.timeoutmsg!=''">{{infosdetail.timeout}} {{infosdetail.timeoutmsg}}</div>
                    </div>
                    <div class="mall-order-sale-after-log-main-content-imgs" v-if="infosdetail.errormsg!=''">原因：{{infosdetail.errormsg}}</div>

                    <div class="mall-order-sale-after-log-main-content-imgs">
                        <div class="mall-order-sale-after-log-main-content-imgs-single" v-for="(item,index) in infosdetail.error_vouch" :key="index">
                            <a @click="showvoucher(infosdetail.error_vouch)" class="mall-order-sale-after-log-main-content-imgs-single-show">
                                <div class="mall-order-sale-after-log-main-content-imgs-cover"><img src="../../assets/enlarge_white.png" /></div>
                                <div class="mall-order-sale-after-log-main-content-imgs-single-img">
                                    <img :src="item!='' ? item : require('../../assets/default_img_mini.png')" />
                                </div>
                            </a>
                        </div>
                    </div>    

                    <div class="mall-order-sale-after-log-isclose" v-if="infosdetail.isclose==1">交易关闭</div>

                </div>

                <div class="mall-order-sale-after-log-main" v-if="infosdetail.refundtype=='退款退货'">
                    <div class="mall-order-sale-after-log-main-title">退货商品信息</div>
                    <div class="mall-order-sale-after-log-main-content" v-for="(item,index) in infosdetail.details" :key="index">
                        <div class="mall-order-sale-after-log-main-content-infos">
                            <div class="mall-order-sale-log-main-content-infos-imgs">
                                <img :src="item.thumb!='' ? item.thumb : require('../../assets/default_img_mini.png')" />
                            </div>
                            <div class="mall-order-sale-log-main-content-infos-names">
                                <div class="mall-order-sale-log-main-content-infos-name">{{item.productname}}</div>
                                <div class="mall-order-sale-log-main-content-infos-spec">规格：{{item.propertyname}}</div>
                            </div>
                            <div class="mall-order-sale-log-main-content-infos-price">成交单价：￥{{item.price}}</div>
                            <div class="mall-order-sale-log-main-content-infos-price">退货数量：{{item.numbers}}</div>
                        </div>
                    </div>
                </div>

                <div class="mall-order-sale-after-log-main">
                    <div class="mall-order-sale-after-log-main-title">退款 / 退货退款信息</div>
                    <div class="mall-order-sale-after-log-main-content">
                        <div class="mall-order-sale-after-log-main-content-details">申请时间：{{infosdetail.inputtime}}</div>
                        <div class="mall-order-sale-after-log-main-content-details">售后单号：{{infosdetail.order_sn}}</div>
                        <div class="mall-order-sale-after-log-main-content-details">售后原因：{{infosdetail.reason_type}}</div>
                        <div class="mall-order-sale-after-log-main-content-details" v-if="infosdetail.reason!=''">原因描述：{{infosdetail.reason}}</div>
                        <div class="mall-order-sale-after-log-main-content-details">退款金额：<i style="margin-left:1%;font-style:normal;font-weight:bold;font-size:14px">￥{{infosdetail.prices}}</i></div>
                        <div class="mall-order-sale-after-log-main-content-details">补充说明：{{infosdetail.description}}</div>
                        <div class="mall-order-sale-after-log-main-content-details">关联线上商城单号：{{infosdetail.ordernumber}}</div>
                        <div class="mall-order-sale-after-log-main-content-details">
                            <div style="display:inline-block">关联订单当前状态：{{infosdetail.order_status}}</div>
                            <div style="display:inline-block" v-if="infosdetail.order_logistics_id > 0">
                                （<a @click="getshippingmsg(infosdetail,1)" class="mall-order-sale-after-log-main-content-shipping">{{infosdetail.order_logistics_name}}_{{infosdetail.order_logistics_code}}</a>
                                  <a @click="getshippingmsg(infosdetail,1)" class="mall-order-sale-after-log-main-content-shipping" v-if="infosdetail.order_logistics_more==1">、更多</a>）
                            </div>
                        </div>
                        <div class="mall-order-sale-after-log-main-content-details" v-if="infosdetail.order_logistics_buyer_id > 0">
                            <div style="display:inline-block">买家寄回物流单号：</div>
                            <div style="display:inline-block" v-if="infosdetail.order_logistics_buyer_id > 0">
                                （<a @click="getshippingmsg(infosdetail,2)" class="mall-order-sale-after-log-main-content-shipping">{{infosdetail.order_logistics_buyer_name}}_{{infosdetail.order_logistics_buyer_code}}</a>
                                  <a @click="getshippingmsg(infosdetail,2)" class="mall-order-sale-after-log-main-content-shipping" v-if="infosdetail.order_logistics_buyer_more==1">、更多</a>）
                            </div>
                        </div>

                        <div class="mall-order-sale-after-log-main-content-details">退货凭证</div>
                        <div class="mall-order-sale-after-log-main-content-imgs" style="width:calc(100% - 20px);margin-left:0 20px 0 0">
                            <div class="mall-order-sale-after-log-main-content-imgs-single" v-for="(item,index) in infosdetail.vouchimgs" :key="index">
                                <a @click="showvoucher(infosdetail.vouchimgs)" class="mall-order-sale-after-log-main-content-imgs-single-show">
                                <div class="mall-order-sale-after-log-main-content-imgs-cover"><img src="../../assets/enlarge_white.png" /></div>
                                <div class="mall-order-sale-after-log-main-content-imgs-single-img">
                                    <img :src="item!='' ? item : require('../../assets/default_img_mini.png')" />
                                </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mall-order-sale-after-log-main">
                    <div class="mall-order-sale-after-log-main-title">操作记录</div>
                    <div class="mall-order-sale-after-log-main-content" style="margin-top:30px"> 
                        <div v-for="(item,index) in infosdetail.handlelog" v-if="infosdetail.handlelognums > 0" :key="index" class="mall-order-sale-after-log-in" :style="item.isend==1 ? 'color:red;border-left:1px solid red' : ''">
                            <div class="mall-order-sale-after-log-in-label" :style="item.isend==1 ? 'background:red' : ''">
                                <div class="mall-order-sale-after-log-in-label-in" :style="item.isend==1 ? 'background:red' : ''"></div>
                            </div>
                            <div class="mall-order-sale-after-log-in-msg">{{item.msg}}（{{item.sysname}}）</div>
                            <div class="mall-order-sale-after-log-in-msg">{{item.time}}</div>
                        </div>
                        <div v-if="infosdetail.handlelognums == 0"  style="display:flex;width:100%;height:100px;justify-content:center;align-items:center;">
                            <img src="../../assets/history_gray.png" style="width:30px;height:30px;display:inline-block" />
                            <div style="font-size:14px;margin-left:2%;color:#777777">暂无操作记录</div>
                        </div>
                    </div>
                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closedetails">取 消</el-button>
            </div>
        </el-dialog>


        <!-- 售后凭证 -->
        <el-dialog title="凭证" :visible.sync="vouchDialog" width="40%" top="5vh">
            <div class="mall-order-sale-after-img-infos" style="display:inline-block;width:100%" v-for="(item,index) in vouchlists" :key="index">
                <img :src="item" style="width:100%"/>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="vouchDialog=false">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 物流轨迹 -->
        <el-dialog title="物流轨迹" :visible.sync="shippingDialog" width="65%" top="5vh">
            <div v-loading="shippingloading">
                <div v-if="shippinginfos.length > 0">
                    <div class="mall-order-sale-log-shippingname-lists">
                        <div v-for="(item,index) in shippinginfos" :key="index" @click="shippingindex=index" class="mall-order-sale-log-shippingname-lists-infos" :style="index==shippingindex ? 'border-bottom:2px solid #e6a23c' : ''">
                            {{item.logisticsname}}_{{item.code}}
                        </div>
                    </div>
                    <div class="mall-order-sale-after-log-out">
                        <div v-for="(item,index) in shippinginfos" :key="index" v-if="index==shippingindex">
                            <div v-for="(tt,ii) in item.trade" :key="ii" v-if="item.trade.length > 0" class="mall-order-sale-after-log-in" :style="tt.isend=='yes' ? 'color:red;border-left:1px solid red;' : '' ">
                                <div class="mall-order-sale-after-log-in-label" :style="tt.isend=='yes' ? 'background:red' : '' ">
                                    <div class="mall-order-sale-after-log-in-label-in" :style="tt.isend=='yes' ? 'background:red' : '' "></div>
                                </div>
                                <div class="mall-order-sale-after-log-in-msg">{{tt.content}}</div>
                                <div class="mall-order-sale-after-log-in-msg">{{tt.msgTime}}</div>
                            </div>
                            <div v-if="item.trade.length == 0" style="display:flex;width:100%;height:200px;justify-content:center;align-items:center;">
                                <img src="../../assets/address_gray.png" style="width:30px;height:30px;display:inline-block" />
                                <div style="font-size:14px;margin-left:2%;color:#777777">暂无物流轨迹信息</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="shippinginfos.length == 0"  style="display:flex;width:100%;height:200px;justify-content:center;align-items:center;">
                    <img src="../../assets/shipping_gray.png" style="width:30px;height:30px;display:inline-block" />
                    <div style="font-size:14px;margin-left:2%;color:#777777">暂无快递信息</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="shippingDialog=false">取 消</el-button>
            </div> 
        </el-dialog>


        <!-- 拒绝退款模块 -->
        <el-dialog title="拒绝退款" :visible.sync="nopayquery.Dialog" width="40%" top="10vh" :before-close="closenorepay">
            <div class="mall-order-refund-refuse-money" v-loading="nopayquery.loading">
                <div class="mall-order-refund-refuse-money-reason">
                    <el-input type="textarea"  v-model="nopayquery.reason" placeholder="请输入不同意退款原因，必填，200字以内" maxlength="200" show-word-limit  :autosize="{ minRows:4, maxRows: 6}"/>
                </div>
                <div class="mall-order-refund-refuse-money-title">上传凭证（非必填）</div>
                <div class="mall-order-refund-refuse-money-reason">
                    <a style="cursor:pointer;" @click="addbannerthumb('refuse_money')">
                    <div class="mall-order-refund-refuse-money-reason-default">
                        <div class="mall-order-refund-refuse-money-reason-default-in">
                            <img src="../../assets/addimg.png" class="mall-order-refund-refuse-money-reason-default-in-img" />
                        </div>
                    </div>
                    </a>

                    <div class="mall-order-refund-refuse-money-reason-vouchimg" v-for="(item,index) in nopayquery.vouchlists" :key="index">
                        <div class="mall-order-refund-refuse-money-reason-vouchimg-in">
                            <a class="mall-order-refund-refuse-money-reason-vouchimg-close" >
                                <img src="../../assets/error.png" class="mall-order-refund-refuse-money-reason-vouchimg-close-img" @click="closenopayvouch(index)" />
                            </a>
                            <img :src="GLOBAL.staticUrl+item" class="mall-order-refund-refuse-money-reason-vouchimg-in-img" />
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer" style="display:inline-block;width:100%;text-align:right;margin-top:30px">
              	  <el-button size="small" @click="nopayquery.Dialog = false">取 消</el-button>
              	  <el-button size="small" type="primary" @click="savenopays">保 存</el-button>
          	    </div>
            </div>
        </el-dialog>


        <!-- 拒绝退货模块 -->
        <el-dialog title="拒绝退货" :visible.sync="noagreerecievequery.Dialog" width="40%" top="10vh" :before-close="closenoagree">
            <div class="mall-order-refund-refuse-money" v-loading="noagreerecievequery.loading">
                <div class="mall-order-refund-refuse-money-reason">
                    <el-input type="textarea"  v-model="noagreerecievequery.reason" placeholder="请输入不同意退货原因，必填，200字以内" maxlength="200" show-word-limit  :autosize="{ minRows:4, maxRows: 6}"/>
                </div>
                <div class="mall-order-refund-refuse-money-title">上传凭证（非必填）</div>
                <div class="mall-order-refund-refuse-money-reason">
                    <a style="cursor:pointer;" @click="addbannerthumb('refuse_goods')">
                    <div class="mall-order-refund-refuse-money-reason-default">
                        <div class="mall-order-refund-refuse-money-reason-default-in">
                            <img src="../../assets/addimg.png" class="mall-order-refund-refuse-money-reason-default-in-img" />
                        </div>
                    </div>
                    </a>

                    <div class="mall-order-refund-refuse-money-reason-vouchimg" v-for="(item,index) in noagreerecievequery.vouchlists" :key="index">
                        <div class="mall-order-refund-refuse-money-reason-vouchimg-in">
                            <a class="mall-order-refund-refuse-money-reason-vouchimg-close" >
                                <img src="../../assets/error.png" class="mall-order-refund-refuse-money-reason-vouchimg-close-img" @click="closenoagreevouch(index)" />
                            </a>
                            <img :src="GLOBAL.staticUrl+item" class="mall-order-refund-refuse-money-reason-vouchimg-in-img" />
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer" style="display:inline-block;width:100%;text-align:right;margin-top:30px">
              	  <el-button size="small" @click="noagreerecievequery.Dialog = false">取 消</el-button>
              	  <el-button size="small" type="primary" @click="savenoagree">保 存</el-button>
          	    </div>
            </div>
        </el-dialog>


        <!-- 拒绝收货模块 -->
        <el-dialog title="拒绝签收" :visible.sync="nosendgetquery.Dialog" width="40%" top="10vh" :before-close="closenosend">
            <div class="mall-order-refund-refuse-money" v-loading="nosendgetquery.loading">
                <div class="mall-order-refund-refuse-money-reason">
                    <el-input type="textarea"  v-model="nosendgetquery.reason" placeholder="请输入不同意签收原因，必填，200字以内" maxlength="200" show-word-limit  :autosize="{ minRows:4, maxRows: 6}"/>
                </div>
                <div class="mall-order-refund-refuse-money-title">上传凭证（非必填）</div>
                <div class="mall-order-refund-refuse-money-reason">
                    <a style="cursor:pointer;" @click="addbannerthumb('refuse_send')">
                    <div class="mall-order-refund-refuse-money-reason-default">
                        <div class="mall-order-refund-refuse-money-reason-default-in">
                            <img src="../../assets/addimg.png" class="mall-order-refund-refuse-money-reason-default-in-img" />
                        </div>
                    </div>
                    </a>

                    <div class="mall-order-refund-refuse-money-reason-vouchimg" v-for="(item,index) in nosendgetquery.vouchlists" :key="index">
                        <div class="mall-order-refund-refuse-money-reason-vouchimg-in">
                            <a class="mall-order-refund-refuse-money-reason-vouchimg-close" >
                                <img src="../../assets/error.png" class="mall-order-refund-refuse-money-reason-vouchimg-close-img" @click="closenosendvouch(index)" />
                            </a>
                            <img :src="GLOBAL.staticUrl+item" class="mall-order-refund-refuse-money-reason-vouchimg-in-img" />
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer" style="display:inline-block;width:100%;text-align:right;margin-top:30px">
              	  <el-button size="small" @click="nosendgetquery.Dialog = false">取 消</el-button>
              	  <el-button size="small" type="primary" @click="savenosend">保 存</el-button>
          	    </div>
            </div>
        </el-dialog>


        <!-- 图片上传模块 -->
        <input type="file" id="bannerthumb" @change="uploadallfiles($event)" multiple style="display:none"/>


        <!-- 对外售后地址 -->
        <el-dialog title="售后商品回寄地址" :visible.sync="settingbuyeraddressquery.Dialog" width="45%" top="10vh">
            <div class="mall-order-refund-address-to-buyer" v-loading="settingbuyeraddressquery.loading">
                <el-button type="danger" size="small" round style="float:right;margin:0 20px 20px 0" @click="addaddressotbuyer">新增地址</el-button>
                
                <div class="mall-order-refund-address-to-buyer-infos" v-if="settingbuyeraddressquery.lists.length > 0" v-for="(item,index) in settingbuyeraddressquery.lists" :key="index">
                    <div class="mall-order-refund-address-to-buyer-infos-left">
                        <a class="mall-order-refund-address-to-buyer-infos-button" @click="setaddressdefault(item)">
                            <img :src="item.isdefault==0 ? require('../../assets/right_default.png') : require('../../assets/right_select.png') " style="width:25px;height:25px"/>
                        </a>
                    </div>
                    <div class="mall-order-refund-address-to-buyer-infos-content">
                        <div class="mall-order-refund-address-to-buyer-infos-content-in">
                        <div class="mall-order-refund-address-to-buyer-infos-name">{{item.name}}<i>{{item.phone}}</i></div>
                        <div class="mall-order-refund-address-to-buyer-infos-city">{{item.showcity}}</div>
                        <div class="mall-order-refund-address-to-buyer-infos-address">{{item.address}}</div>
                        </div>
                    </div>
                    <div class="mall-order-refund-address-to-buyer-infos-right">
                        <a class="mall-order-refund-address-to-buyer-infos-button" @click="geteditaddress(item)"><img src="../../assets/address_edit.png" /></a>
                        <a class="mall-order-refund-address-to-buyer-infos-button-del" @click="deladdress(item)"><img src="../../assets/minus.png" /></a>
                    </div>   
                </div>
                <div v-if="settingbuyeraddressquery.lists.length == 0" style="display:flex;justify-content:center;align-items:center;width:100%;height:100px">
                    <img src="../../assets/address_gray.png" style="width:30px;height:30px;display:inline-block" />
                    <div style="font-size:14px;margin-left:2%;color:#777777">您还没有添加售后地址</div>
                </div>
            </div>
        </el-dialog>

        <!-- 新增 / 编辑售后地址 -->
        <el-dialog title="新增 / 编辑售后地址" :visible.sync="settingbuyersaveaddressquery.Dialog" width="40%" top="10vh">
            <div v-loading="settingbuyersaveaddressquery.loading">
            <el-form size="mini">
                <el-form-item label="收货姓名" label-width="120">
					<el-input type="text" size="small" v-model="settingbuyersaveaddressquery.name" style="width:70%"/>
			    </el-form-item>
                <el-form-item label="收货电话" label-width="120">
					<el-input type="text" size="small" v-model="settingbuyersaveaddressquery.phone" style="width:70%"/>
			    </el-form-item>
                <el-form-item label="选择省份" label-width="120" >
					<el-select v-model="settingbuyersaveaddressquery.provinceid" remote  filterable placeholder="请选择省份" @change="changeprovince(settingbuyersaveaddressquery.provinceid)">	            
						<el-option v-for="(item,index) in provincelists" :label="item.name" :value="item.id" :key="index">
                            <span style="float: left">{{item.name}}</span>
							<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                        </el-option>             
					</el-select>
			    </el-form-item>
                <el-form-item label="选择城市" label-width="120" v-if="citylists.length > 0">
					<el-select v-model="settingbuyersaveaddressquery.cityid" remote  filterable placeholder="请选择城市" @change="changecity(settingbuyersaveaddressquery.cityid)">	            
						<el-option v-for="(item,index) in citylists" :label="item.name" :value="item.id" :key="index">
                            <span style="float: left">{{item.name}}</span>
							<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                        </el-option>             
					</el-select>
			    </el-form-item>
                <el-form-item label="区域/县份" label-width="120" v-if="townlists.length > 0">
					<el-select v-model="settingbuyersaveaddressquery.townid" remote  filterable placeholder="请选择区域/县份" @change="changetown(settingbuyersaveaddressquery.townid)">	            
						<el-option v-for="(item,index) in townlists" :label="item.name" :value="item.id" :key="index">
                            <span style="float: left">{{item.name}}</span>
							<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                        </el-option>                          
					</el-select>
			    </el-form-item>
                <el-form-item label="城镇/村落" label-width="120" v-if="countrylists.length > 0">
					<el-select v-model="settingbuyersaveaddressquery.countryid" remote  filterable placeholder="请选择城镇/村落">	            
						<el-option v-for="(item,index) in countrylists" :label="item.name" :value="item.id" :key="index">
                            <span style="float: left">{{item.name}}</span>
							<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                        </el-option>    
                    </el-select>         
			    </el-form-item>
                <el-form-item label="详细地址" label-width="120">
					<el-input type="textarea" size="small" v-model="settingbuyersaveaddressquery.address" placeholder="请填写详细地址" maxlength="200" show-word-limit  :autosize="{ minRows:4, maxRows: 6}" style="width:70%"/>
			    </el-form-item>
                <el-form-item label="默认地址" label-width="120">
					<el-radio v-model="settingbuyersaveaddressquery.isdefault" label="0">否</el-radio>
                    <el-radio v-model="settingbuyersaveaddressquery.isdefault" label="1">是</el-radio>
			    </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="display:inline-block;width:100%;text-align:right;margin-top:30px">
              	  <el-button size="small" @click="settingbuyersaveaddressquery.Dialog = false">取 消</el-button>
              	  <el-button size="small" type="primary" @click="updateaddresstobuyer">保 存</el-button>
          	</div>
            </div>
        </el-dialog>


        <!-- 批量操作返回结果集合 -->
        <el-dialog title="批量操作结果" :visible.sync="showmoremsgDialog" width="40%" top="10vh" :before-close="closemoreresult">
            <div class="mall-order-refund-msg-more-result-out">
            <div class="mall-order-refund-msg-more-result" v-for="(item,index) in showmoremsg" :key="index">
                <img :src="item.status==0 ? require('../../assets/right_select.png') : require('../../assets/error.png') " />
                <div class="mall-order-refund-msg-more-result-content">{{item.msg}}</div>
            </div>
            </div>
        </el-dialog>



				
    </div>
    </transition>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      actionauth:'', //功能权限
      transitionshow:true,
      url:this.GLOBAL.domain+"OrderRefund/index",

      query: {
        act:'lists',
        token:this.$cookies.get('token'),
        refund_type:'',
        order_status:'',
        refund_status:'',
        inter_status:'',
        refund_reason_type:'',
        time_filter:1,
        time:[],
        shop_name:'',
        order_sn:'',
        refund_sn:'',
        shipping_sn:'',
        p:1,
        rollpage:10,
        rows:0,
        ischange:false,
        loading:false
      },
      lists:[],

      ordertypes:[],
      returntypes:[],
      orderstatus:[],
      intertypes:[],
      refundreasontypes:[],
      timetypes: [],

      logDialog:false,
      logloading:false,
      loginfos:[],

      infosDialog:false,
      infoloading:false,
      infosdetail: {
          
      },
      
      vouchDialog:false,
      vouchlists:[],
      
      shippingDialog:false,
      shippingloading:false,
      shippingindex:0,
      shippinginfos:[],
      timeoutflag:false,
      timeoutobj:'',
      timeoutobjlists:'',
      refundtemps:[],
      
      uploadimgtype:'',
      nopayquery: {
          id:'',
          reason:'',
          vouchlists:[],
          Dialog:false,
          loading:false,
      },
      noagreerecievequery: {
          id:'',
          reason:'',
          vouchlists:[],
          Dialog:false,
          loading:false,
      },
      nosendgetquery: {
          id:'',
          reason:'',
          vouchlists:[],
          Dialog:false,
          loading:false,
      },

      settingbuyeraddressquery: {
          act:'getaddress_to_buyer',
          token:this.$cookies.get('token'),
          Dialog:false,
          loading:false,
          lists:[],
      },

      settingbuyersaveaddressquery: {
          act:'saveaddress_to_buyer',
          token:this.$cookies.get('token'),
          Dialog:false,
          loading:false,
          id:'',
          provinceid:'',
          cityid:'',
          townid:'',
          countryid:'',
          provincename:'',
          cityname:'',
          townname:'',
          countryname:'',
          address:'',
          isdefault:'',
          name:'',
          phone:'',
      },

      provincelists:[],
      citylists:[],
      townlists:[],
      countrylists:[],

      showmoremsgDialog:false,
      showmoremsg:[],



    }  
  },
    
  mounted(){  
      this.getactionauth();
      this.getcategorygroup();  //获取搜索分类信息集群
      this.getlists();          //获取售后单信息列表
  },
  
  methods:{


      //导出售后订单信息
      exportdata() {
          if (this.query.time.length < 2) {
            this.$message.error('请选择时间范围再导出数据！');
            return
          }
          var url=this.url;
          for(var p in this.query) {
              p=='act' ? this.query[p]='exportdata' : '';
              if(p=='time' && this.query[p].length > 0) {
                  this.query[p] ? url+='/'+p+'/'+this.query[p] : '';
              }else if(p!='time' && this.query[p]) {
                  url+='/'+p+'/'+this.query[p];
              }
          }
          location.href=url; //下载
      },
      

      /////////////////////////////////////////////////////////////////////////////////////////////////
      //商家地址信息设置

      //设置售后收货地址
      settingaddresstobuyer() {
          this.settingbuyeraddressquery.Dialog=true;
          this.settingbuyeraddressquery.loading=true;
          var resource = this.$resource(this.url);
          resource.save({ act:'getaddresslists',token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.settingbuyeraddressquery.loading=false;
              }else{
                  this.settingbuyeraddressquery.lists = JSON.parse(Base64.decode(res.data.Data));
                  this.settingbuyeraddressquery.loading=false;
              }
          }).catch((res) => {
              this.settingbuyeraddressquery.loading=false;
          });

      },

      //打开新增收货地址页
      addaddressotbuyer() {
          this.settingbuyersaveaddressquery.act='saveaddress_to_buyer';
          this.settingbuyersaveaddressquery.Dialog=true;
          this.settingbuyersaveaddressquery.id='';
          this.settingbuyersaveaddressquery.provinceid='';
          this.settingbuyersaveaddressquery.cityid='';
          this.settingbuyersaveaddressquery.townid='';
          this.settingbuyersaveaddressquery.countryid='';
          this.settingbuyersaveaddressquery.provincename='';
          this.settingbuyersaveaddressquery.cityname='';
          this.settingbuyersaveaddressquery.townname='';
          this.settingbuyersaveaddressquery.countryname='';
          this.settingbuyersaveaddressquery.address='';
          this.settingbuyersaveaddressquery.isdefault='0';
          this.settingbuyersaveaddressquery.name='';
          this.settingbuyersaveaddressquery.phone='';
          this.getprovincelists(); //获取一级省份地址信息
      },


      //获取新增收货地址信息
      geteditaddress(item) {
          this.settingbuyersaveaddressquery.act='updateaddress_to_buyer';
          this.settingbuyersaveaddressquery.Dialog=true;
          this.settingbuyersaveaddressquery.id=item.id;
          this.settingbuyersaveaddressquery.provinceid='';
          this.settingbuyersaveaddressquery.cityid='';
          this.settingbuyersaveaddressquery.townid='';
          this.settingbuyersaveaddressquery.countryid='';
          this.settingbuyersaveaddressquery.provincename='';
          this.settingbuyersaveaddressquery.cityname='';
          this.settingbuyersaveaddressquery.townname='';
          this.settingbuyersaveaddressquery.countryname='';
          this.settingbuyersaveaddressquery.address='';
          this.settingbuyersaveaddressquery.isdefault='0';
          this.settingbuyersaveaddressquery.name='';
          this.settingbuyersaveaddressquery.phone='';

          this.settingbuyersaveaddressquery.loading=true;
          var resource = this.$resource(this.url);
          resource.save({ act:'getaddressdetail',id:item.id,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.settingbuyersaveaddressquery.loading=false;
              }else{
                  var result = JSON.parse(Base64.decode(res.data.Data));
                  this.settingbuyersaveaddressquery.name=result.name;
                  this.settingbuyersaveaddressquery.phone=result.phone;
                  this.settingbuyersaveaddressquery.address=result.address;
                  this.settingbuyersaveaddressquery.isdefault=result.isdefault==0 ? '0' : '1';

                  //获取省份信息
                  this.getprovincelists();
                  this.settingbuyersaveaddressquery.provinceid=result.provinceid;
                  //获取城市地址信息
                  this.changeprovince(result.provinceid);
                  this.settingbuyersaveaddressquery.cityid=result.cityid;
                  //获取区域/县份信息
                  this.changecity(result.cityid);
                  this.settingbuyersaveaddressquery.townid=result.townid;
                  //获取乡镇/村落信息
                  if(result.countryid > 0) {
                      this.changetown(result.townid);
                      this.settingbuyersaveaddressquery.countryid=result.countryid;
                  }

                  this.settingbuyersaveaddressquery.loading=false;
              }
          }).catch((res) => {
              this.settingbuyeraddressquery.loading=false;
          });  
      },


      //删除售后地址信息
      deladdress(item) {
          this.$confirm('您是否要删除当前地址信息', '提示', { type: 'warning' }).then(() => {			
                var resource = this.$resource(this.url);
                resource.save({ act:'deladdress',id:item.id,token:this.$cookies.get('token')}).then((res) => {
                    if(res.data.Result>0){
                        if(res.data.Result=='70001') this.$router.push('/login')
                        this.$message.error(res.data.Message);
                    }else{
                        this.settingaddresstobuyer();  
                    }
                }).catch((res) => {
                    
                });  

		  }).catch(() => {
						
		  });
      },


      //设置默认地址信息
      setaddressdefault(item) {
          var resource = this.$resource(this.url);
          resource.save({ act:'setaddressisdefault',id:item.id,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.settingaddresstobuyer();  
              }
          }).catch((res) => {
                    
          });  

      },

      
      //获取省份信息
      getprovincelists() {
          this.settingbuyersaveaddressquery.provinceid='';
          this.settingbuyersaveaddressquery.cityid='';
          this.settingbuyersaveaddressquery.townid='';
          this.settingbuyersaveaddressquery.countryid='';
          this.settingbuyersaveaddressquery.provincename='';
          this.settingbuyersaveaddressquery.cityname='';
          this.settingbuyersaveaddressquery.townname='';
          this.settingbuyersaveaddressquery.countryname='';
          this.provincelists=[];
          this.citylists=[];
          this.townlists=[];
          this.countrylists=[];
          this.getcitylists(0,'province');
      },

      //修改省份信息
      changeprovince(id) {
          this.settingbuyersaveaddressquery.cityid='';
          this.settingbuyersaveaddressquery.townid='';
          this.settingbuyersaveaddressquery.countryid='';
          this.settingbuyersaveaddressquery.cityname='';
          this.settingbuyersaveaddressquery.townname='';
          this.settingbuyersaveaddressquery.countryname='';
          this.citylists=[];
          this.townlists=[];
          this.countrylists=[];
          this.getcitylists(id,'city');
      },

      //修改城市
      changecity(id) {
          this.settingbuyersaveaddressquery.townid='';
          this.settingbuyersaveaddressquery.countryid='';
          this.settingbuyersaveaddressquery.townname='';
          this.settingbuyersaveaddressquery.countryname='';
          this.townlists=[];
          this.countrylists=[];
          this.getcitylists(id,'town');
      },

      //修改区域/县份
      changetown(id) {
          this.settingbuyersaveaddressquery.countryid='';
          this.settingbuyersaveaddressquery.countryname='';
          this.countrylists=[];
          this.getcitylists(id,'country');
      },

      
      //获取省份数据
      getcitylists(id,type) {
          this.settingbuyersaveaddressquery.loading=true;
          var resource = this.$resource(this.url);
          resource.save({ act:'getrefundaddress',id:id,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.settingbuyersaveaddressquery.loading=false;
              }else{
                  var result = JSON.parse(Base64.decode(res.data.Data));
                  if(type=='province') this.provincelists=result;
                  if(type=='city') this.citylists=result;
                  if(type=='town') this.townlists=result;
                  if(type=='country') this.countrylists=result;
                  this.settingbuyersaveaddressquery.loading=false;
              }
          }).catch((res) => {
              this.settingbuyersaveaddressquery.loading=false;
          });
      },


      //保存 / 编辑地址信息
      updateaddresstobuyer() {
          if(this.provincelists.length > 0 && this.settingbuyersaveaddressquery.provinceid=='') {this.$message.error("请选择省份");return false;}
          if(this.citylists.length > 0 && this.settingbuyersaveaddressquery.cityid=='') {this.$message.error("请选择城市");return false;}
          if(this.townlists.length > 0 && this.settingbuyersaveaddressquery.townid=='') {this.$message.error("请选择区域/县城");return false;}
          if(this.countrylists.length > 0 && this.settingbuyersaveaddressquery.countryid=='') {this.$message.error("请选择乡镇/村落");return false;}

          this.settingbuyersaveaddressquery.loading=true;
          var resource = this.$resource(this.url);
          resource.save(this.settingbuyersaveaddressquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.settingbuyersaveaddressquery.loading=false;
              }else{
                  this.settingbuyersaveaddressquery.loading=false;
                  this.settingbuyersaveaddressquery.Dialog=false;
                  this.settingaddresstobuyer();
              }
          }).catch((res) => {
              this.settingbuyersaveaddressquery.loading=false;
          });
      },

      ////////////////////////////////////////////////////////////////////////////////////////////////



      //////////////////////////////////////////////////////////////////////////////////////////////
      //退款模块
      //去付款
      gopay(item,type) {
          var ids=[];
          ids.push(item.id);
          this.gotopays(ids,type);  //退款函数
      },

      //批量去付款
      gopaymore(type) {
          var ids=this.refundtemps;
          this.gotopays(ids,type);  //退款函数
      },

      //拒绝退款
      nogopay(item) {
          this.nopayquery.id=item.id;
          this.nopayquery.reason='';
          this.nopayquery.vouchlists=[];
          this.nopayquery.Dialog=true;
      },

      //删除拒绝退款商品信息
      closenopayvouch(index) {
          this.$delete(this.nopayquery.vouchlists,index);
      },

      //保存拒绝退款信息
      savenopays() {
          var ids=[];
          ids.push(this.nopayquery.id);
          this.gotopays(ids,2,this.nopayquery.reason,this.nopayquery.vouchlists);
      },

      //误操作关闭当前窗口
      closenorepay() {
          this.$confirm('您是否确定要放弃当前所编辑的信息关闭当前窗口？', '提示', { type: 'warning' }).then(() => {
			  this.nopayquery.Dialog=false;	
		  }).catch(() => {
						
	      });
      },

      //执行具体退款流程
      gotopays(ids,type,error_msg='',vouchimg=[]) {
          var content="您是否需要对已选中的售后单做";
          type==1 ? content+="同意退款处理，并将约定退款金额原路退回对方账号" : content+="拒绝退款处理";
          this.$confirm(content, '提示', { type: 'warning' }).then(() => {
              var resource = this.$resource(this.url);
              resource.save({ act:'gotopays',ids:ids,type:type,error_msg:error_msg,vouchimg:vouchimg,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')

                      var resultdata=res.data.Message;
                      if(resultdata.status==1) {this.$message.error(resultdata.msg);return false;}
                      
                      this.showmoremsgDialog=true;
                      this.showmoremsg=resultdata.msg;
                      this.refundtemps=[];

                  }else{
                      this.getlists();
                      this.nopayquery.Dialog=false;
                      this.refundtemps=[];
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
               });
          }).catch(() => {
              
          });
      },
      /////////////////////////////////////////////////////////////////////////////////////////////////


      ////////////////////////////////////////////////////////////////////////////////////////////////
      //退货操作

      //同意退货
      agreerecieve(item,type) {
          var ids=[];
          ids.push(item.id);
          this.gotoagreement(ids,type); //执行同意退货操作
      },

      //执行批量同意退货
      agreerecievemore(type) {
          var ids=this.refundtemps;
          this.gotoagreement(ids,type);  //退款函数
      },

      //执行具体同意退货流程
      gotoagreement(ids,type,error_msg='',vouchimg=[]) {
          var content="您是否需要对已选中的售后单做";
          type==1 ? content+="同意退货处理" : content+="拒绝退货处理";
          this.$confirm(content, '提示', { type: 'warning' }).then(() => {
              var resource = this.$resource(this.url);
              resource.save({ act:'gotoagreement',ids:ids,type:type,error_msg:error_msg,vouchimg:vouchimg,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      var resultdata=res.data.Message;
                      if(resultdata.status==1) {this.$message.error(resultdata.msg);return false;}
                      
                      this.showmoremsgDialog=true;
                      this.showmoremsg=resultdata.msg;
                      this.refundtemps=[];

                  }else{
                      this.getlists();
                      this.noagreerecievequery.Dialog=false;
                      this.refundtemps=[];
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
               });
          }).catch(() => {
              
          });
      },

      //拒绝退货
      noagreerecieve(item) {
          this.noagreerecievequery.id=item.id;
          this.noagreerecievequery.reason='';
          this.noagreerecievequery.vouchlists=[];
          this.noagreerecievequery.Dialog=true;
      },
      
      //误操作关闭当前窗口
      closenoagree() {
          this.$confirm('您是否确定要放弃当前所编辑的信息关闭当前窗口？', '提示', { type: 'warning' }).then(() => {
			  this.noagreerecievequery.Dialog=false;	
		  }).catch(() => {
						
	      });
      },

      //删除凭证信息
      closenoagreevouch(index) {
          this.$delete(this.noagreerecievequery.vouchlists,index);
      },

      //保存拒绝退货信息
      savenoagree() {
          var ids=[];
          ids.push(this.noagreerecievequery.id);
          this.gotoagreement(ids,2,this.noagreerecievequery.reason,this.noagreerecievequery.vouchlists);
      },

      ///////////////////////////////////////////////////////////////////////////////////////////////


      //////////////////////////////////////////////////////////////////////////////////////////////
      //拒绝收货
      
      //执行收货操作
      sendget(item,type) {
          var ids=[];
          ids.push(item.id);
          this.gotosendget(ids,type);  //执行收货函数
      },

      //拒绝收货窗口打开
      nosendget(item) {
          this.nosendgetquery.id=item.id;
          this.nosendgetquery.reason='';
          this.nosendgetquery.vouchlists=[];
          this.nosendgetquery.Dialog=true;
      },
      
      //误操作关闭窗口
      closenosend() {
          this.$confirm('您是否确定要放弃当前所编辑的信息关闭当前窗口？', '提示', { type: 'warning' }).then(() => {
			  this.nosendgetquery.Dialog=false;	
		  }).catch(() => {
						
	      });
      },

      //删除凭证
      closenosendvouch(index) {
          this.$delete(this.nosendgetquery.vouchlists,index);
      },

      //保存提交凭证
      savenosend() {
          var ids=[];
          ids.push(this.nosendgetquery.id);
          this.gotosendget(ids,2,this.nosendgetquery.reason,this.nosendgetquery.vouchlists);
      },

      //执行收货函数
      gotosendget(ids,type,error_msg='',vouchimg=[]) {
          var content="您是否需要对已选中的售后单做";
          type==1 ? content+="确认收货处理" : content+="拒绝收货处理";
          this.$confirm(content, '提示', { type: 'warning' }).then(() => {
              var resource = this.$resource(this.url);
              resource.save({ act:'sendget',ids:ids,type:type,error_msg:error_msg,vouchimg:vouchimg,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')

                      var resultdata=res.data.Message;
                      if(resultdata.status==1) {this.$message.error(resultdata.msg);return false;}
                      
                      this.nosendgetquery.Dialog=true;
                      this.showmoremsg=resultdata.msg;
                      this.refundtemps=[];

                  }else{
                      this.nosendgetquery.Dialog=false;
                      this.getlists();
                      this.refundtemps=[];
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
               });
          }).catch(() => {
              
          });
      },
      
      /////////////////////////////////////////////////////////////////////////////////////////////




      //触发上传图片
      addbannerthumb(type) {
		  this.uploadimgtype=type;
		  document.getElementById('bannerthumb').click();
	  },

      /** 批量上传图片 **/
	  uploadallfiles(el) {
          var uploadimgtype=this.uploadimgtype;
          var _this=this;
		  var resource = this.$resource(this.GLOBAL.uploadUrl);
	      for (let i = 0; i < el.target.files.length; i++) {
	    	  var formData = new FormData();
	    	  formData.append('file', el.target.files[i]);
              formData.append('sys_type', 'cz');
              formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    	  resource.save(formData).then((res) => {
		          var data=JSON.parse(Base64.decode(res.body.Data));
		          if(data.Result > 0) {
		              this.$message.error(data.msg);
		          }else {
                      if(uploadimgtype=='refuse_money') _this.nopayquery.vouchlists.push(data.imgsrc);
                      if(uploadimgtype=='refuse_goods') _this.noagreerecievequery.vouchlists.push(data.imgsrc);	 
                      if(uploadimgtype=='refuse_send') _this.nosendgetquery.vouchlists.push(data.imgsrc);	             	
		          }
		      }).catch((res) => {
		        	
		      });
	      }
		  el.target.value = '';
	   },


      //单选售后单
      orderselect(val,row) {
          var number=this.refundtemps.indexOf(row.id);
          number==-1 ? this.refundtemps.push(row.id) : this.$delete(this.refundtemps,number);
      },

      orderselectall(val) {
          var _this=this;
          var number=-1;
          if(val.length > 0) { //新增商品
              val.forEach(function(item,i) {
                  number=_this.refundtemps.indexOf(item.id);
                  number==-1 ? _this.refundtemps.push(item.id) : '';
              });

          }else { //删除商品
              this.lists.forEach(function(item,i) {
                  number=_this.refundtemps.indexOf(item.id);
                  number > -1 ? _this.$delete(_this.refundtemps,number) : '';
              });
          }
      },

      //清空已选中的售后单
      clearrefundorder() {
          this.refundtemps=[];
          this.getlists();
      },


      //查询售后单列表信息
      getlists() {
         if(this.query.ischange) {
             this.query.p=1;
             this.query.rollpage=10;
         }

         this.query.loading=true;
         var resource = this.$resource(this.url);
         resource.save(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading=false;
            }else{
                this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.query.rows=parseInt(res.data.count);
                this.query.loading=false;
                if(this.query.ischange) this.query.ischange=false;

                var _this=this;
                setTimeout(function() {
                    _this.lists.forEach(function(e,index){  
                        _this.refundtemps.indexOf(e.id) >=0 ? _this.$refs.goodsmultipleTable.toggleRowSelection(e) : '';
                    });
                },200);

                //有超时提醒的设置超时时间倒计时
                //清除晶振
                clearInterval(this.timeoutobjlists);
                this.timeoutobjlists=setInterval(function() {
                    _this.lists.forEach(function(item,index) {
                        _this.showliststimeout(item);
                    });
                },1000);  

            }
         }).catch((res) => {
            this.query.loading=false;
         });
      },


      /** 下一页 **/
  	  pageSizeChange(val) {
  	      this.query.rollpage = val;
          this.getlists();
  	  },
  	  /** 下一页 **/
  	  pageCurrentChange(val) {
  	      this.query.p = val;
          this.getlists();
  	  },


     //查看物流轨迹
     getshippingmsg(item,type) {
         this.shippingDialog=true;
         this.shippingloading=true;
         this.shippinginfos=[];
         this.shippingindex=0;
         var resource = this.$resource(this.url);
         resource.save({ act:'shipping_trade',token:this.$cookies.get('token'),id:item.id,type:type}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.shippingloading=false;
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
				this.shippinginfos=result;
                this.shippingloading=false;
            }
         }).catch((res) => {
            this.shippingloading=false;
         });

     },

    //查看凭证
    showvoucher(item) {
        this.vouchlists=item;
        this.vouchDialog=true;
    },


    //获取售后单详情
    getafterdetails(item) {
        this.infosDialog=true;
        this.infoloading=true;

        var resource = this.$resource(this.url);
         resource.save({ act:'detail',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.infoloading=false;
            }else{
                this.infosdetail = JSON.parse(Base64.decode(res.data.Data));
                this.infoloading=false;

                //超时时间显示倒计时提示
                this.timeoutflag=true;
                this.infosdetail.temptimeout=this.infosdetail.timeout;
                clearInterval(this.timeoutobj);
                this.timeoutobj=setInterval(this.showtimeout,1000);

            }
         }).catch((res) => {
            this.infoloading=false;
         });
    },

    //关闭详情页窗口
    closedetails() {
        this.infosDialog=false;
    },


    //超时时间倒计时函数
    showtimeout() {
        if(this.infosdetail.temptimeout==0) {
            this.infosdetail.timeout='0 天 0 时 0 分 0 秒';
            clearInterval(this.timeoutobj);
            return false;
        }

        this.infosdetail.temptimeout--;
        var days=''; var hourse=''; var minus=''; var s='';

        days=Math.floor(this.infosdetail.temptimeout / 86400);
        hourse=Math.floor(this.infosdetail.temptimeout % 86400 / 3600);
        minus=Math.floor(this.infosdetail.temptimeout % 86400 % 3600 / 60);
        s=Math.floor(this.infosdetail.temptimeout % 86400 % 3600 % 60);

        this.infosdetail.timeout=days+' 天 '+hourse+' 时 '+minus+' 分 '+s+' 秒 ';
    },


    //售后单列表时间倒计时
    showliststimeout(item) {
        if(item.temptimeout==0) {
            item.timeout='0 天 0 时 0 分 0 秒';
            clearInterval(item);
            return false;
        }

        item.temptimeout--;
        var days=''; var hourse=''; var minus=''; var s='';

        days=Math.floor(item.temptimeout / 86400);
        hourse=Math.floor(item.temptimeout % 86400 / 3600);
        minus=Math.floor(item.temptimeout % 86400 % 3600 / 60);
        s=Math.floor(item.temptimeout % 86400 % 3600 % 60);

        item.timeout=days+' 天 '+hourse+' 时 '+minus+' 分 '+s+' 秒 ';
    },



    //获取操作记录信息
    getafterlogs(item) {
         this.logDialog=true;
         this.logloading=true;
         this.loginfos=[];
         var resource = this.$resource(this.url);
         resource.save({ act:'refundlogs',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.logloading=false;
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
				this.loginfos=result;
                this.logloading=false;
            }
         }).catch((res) => {
            this.logloading=false;
         });
    },


    //获取售后分类信息集群
    getcategorygroup() {
         var resource = this.$resource(this.url);
         resource.save({ act:'categorygroup',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
                this.ordertypes=result.ordertypes;                  //退款订单类型
                this.returntypes=result.returntypes;                //退款原销售订单状态
                this.orderstatus=result.orderstatus;                //退款订单状态
                this.intertypes=result.intertypes;                  //小二介入状态
                this.refundreasontypes=result.refundreasontypes;    //退款原因
                this.timetypes=result.timetypes;                    //时间筛选类型
            }
         }).catch((res) => {
            this.shippingloading=false;
         });
    },

    //批操作关闭窗口
    closemoreresult() {
        this.showmoremsgDialog=false;
        this.nopayquery.Dialog=false;
        this.noagreerecievequery.Dialog=false;
        this.nosendgetquery.Dialog=false;
        this.getlists();
    },

    
    //获取功能权限
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },


  } 
}
</script>

<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}

.mall-order-sale-after-ordernumbers {float:left;width:100%;}
.mall-order-sale-after-orders {font-size:13px;line-height:25px;float:left;}
.mall-order-sale-after-status {font-size:13px;line-height:25px;float:left;}
.mall-order-sale-after-orders-error {float:left;padding:1px 4px;border-radius:50%;border:1px solid #e6a23c;background:#e6a23c;color:#fff;font-style:normal;text-align:center;font-size:12px;line-height:12px;margin-left:5px;margin-top:4px;}
.mall-order-sale-after-order-status {font-size:12px;line-height:23px;float:left;}
.mall-order-sale-after-goods-out {float:left;width:70px;height:70px;}
.mall-order-sale-after-goods-in {float:left;width:60px;height:60px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.3);border-radius:6px;display:flex;justify-content:center;align-items:center}
.mall-order-sale-after-goods-in img  {border-radius:6px;max-width:100%;max-height:100%}
.mall-order-sale-after-goods-lists {float:left;height:68px;margin-left:2%;width:calc(100% - 70px - 2%);}
.mall-order-sale-after-goods-name {float:left;width:100%;font-size:13px;line-height:21px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.mall-order-sale-after-goods-spec {float:left;width:100%;font-size:12px;line-height:21px;color:#999999;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.mall-order-sale-after-buyer {font-size:13px;line-height:21px;float:left;font-size:13px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.mall-order-sale-after-buyer-reason {font-size:13px;line-height:21px;float:left;width:100%;font-size:13px;text-align:center}
.mall-order-sale-after-create-time {float:left;width:100%;font-size:13px}
.mall-order-sale-after-log-out {display:inline-block;width:90%;padding:0 5%;}
.mall-order-sale-after-log-in {float:left;width:calc(95% - 1px);padding:0 0 20px 5%;border-left:1px solid #dddddd;position:relative}
.mall-order-sale-after-log-in-label {position:absolute;width:15px;height:15px;background:rgba(221,221,221);border-radius:50%;left:0;top:0;margin:-7.5px 0 0 -7.5px;display:flex;justify-content:center;align-items:center}
.mall-order-sale-after-log-in-label-in {width:12px;height:12px;border-radius:50%;background:rgba(221,221,221)}
.mall-order-sale-after-log-in-msg {float:left;font-size:12px;line-height:24px;width:100%}
.mall-order-sale-after-log-detail {display:inline-block;width:100%}
.mall-order-sale-after-log-main {display:inline-block;width:100%;padding-bottom:30px}
.mall-order-sale-after-log-main-title {display:inline-block;width:100%;font-size:15px;font-weight:550}
.mall-order-sale-after-log-main-content {padding:10px 20px;display:inline-block;width:calc(100% - 40px);font-size:0;}
.mall-order-sale-after-log-main-content-status {display:inline-block;font-size:13px}
.mall-order-sale-after-log-main-content-question {display:inline-block;font-size:12px;line-height:12px;padding:2px 5px;color:#fff;background:rgb(230, 162, 60);border:1px solid rgb(230, 162, 60);border-radius:50%;text-align:center}
.mall-order-sale-after-log-main-content-warning {display:inline-block;color:red;font-size:13px;margin-left:3%}
.mall-order-sale-after-log-main-content-infos {float:left;width:100%;padding:5px 0}
.mall-order-sale-log-main-content-infos-imgs {float:left;width:60px;height:60px;display:flex;justify-content:center;align-items:center;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.3);border-radius:6px;}
.mall-order-sale-log-main-content-infos-imgs img  {max-width:85%;max-height:85%;border-radius:6px}
.mall-order-sale-log-main-content-infos-names {float:left;width:45%;height:62px;margin-left:1%;}
.mall-order-sale-log-main-content-infos-name {float:left;width:100%;font-size:13px;line-height:23px;}
.mall-order-sale-log-main-content-infos-spec {float:left;width:100%;font-size:12px;line-height:23px;color:#999999}
.mall-order-sale-log-main-content-infos-price {float:left;width:20%;height:62px;display:flex;justify-content:center;align-items:center;font-size:13px;}
.mall-order-sale-after-log-main-content-details {padding:10px 0;font-size:13px;line-height:23px;}
.mall-order-sale-after-log-main-content-imgs {width:calc(100% - 40px );font-size:13px;color:red;margin:0 20px 0 20px;line-height:18px;}
.mall-order-sale-after-log-main-content-imgs-single {float:left;width:82px;height:82px;position:relative;margin:2% 10px 0 0;}
.mall-order-sale-after-log-main-content-imgs-single-show {float:left;cursor:pointer;}
.mall-order-sale-after-log-main-content-imgs-cover {opacity:0;position:absolute;width:100%;height:100% !important;top:0;left:0;border-radius:6px;background-color:rgba(0,0,0,.8);display:flex;justify-content:center;align-items:center;"><img src="../../assets/enlarge_white.png" style="width:20px;height:20px;transition:.5s all;}
.mall-order-sale-after-log-main-content-imgs-cover img {width:20px;height:20px;}
.mall-order-sale-after-log-main-content-imgs-single-show:hover > .mall-order-sale-after-log-main-content-imgs-cover {opacity:1;}
.mall-order-sale-after-log-main-content-imgs-single-img {float:left;width:80px;height:80px;border:1px solid rgba(221,221,221,.7);border-radius:6px;background:rgba(221,221,221,.3);display:flex;justify-content:center;align-items:center}
.mall-order-sale-after-log-main-content-imgs-single-img img {max-width:85%;max-height:85%;border-radius:6px}

.mall-order-sale-after-log-main-content-shipping {cursor:pointer;font-weight:bold;font-size:13px;}
.mall-order-sale-log-shippingname-lists {float:left;width:100%;padding:20px 0 40px 0;font-size:13px}
.mall-order-sale-log-shippingname-lists-infos {float:left;padding:10px 20px;cursor:pointer;}
.mall-order-sale-after-goods-isclose {margin:5px 0 0 -10px;font-size:13px;line-height:18px;padding:10px;color:#F56C6C;transform:rotate(-45deg);width:54px;height:54px;border:3px solid #F56C6C;border-radius:50%;text-align:center;position:absolute;top:0;left:0;display:flex;justify-content:center;align-items:center;font-weight:bold}
.mall-order-sale-after-log-isclose {margin:5px 0 0 -10px;font-size:18px;line-height:25px;padding:10px;color:#F56C6C;transform:rotate(45deg);width:52px;height:52px;border:3px solid #F56C6C;border-radius:50%;text-align:center;position:absolute;top:0;right:0;margin-right:20px;display:flex;justify-content:center;align-items:center;font-weight:bold}
.mall-order-refund-refuse-money-reason {display:inline-block;width:100%}
.mall-order-refund-refuse-money-title {display:inline-block;width:100%;font-size:14px;padding:20px 0 10px 0}
.mall-order-refund-refuse-money-reason {display:inline-block;width:100%}
.mall-order-refund-refuse-money-reason-default {display:inline-block;width:80px;height:80px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.3);margin:0 10px 10px 0;border-radius:6px;}
.mall-order-refund-refuse-money-reason-default-in {float:left;width:100%;height:80px;display:flex;justify-content:center;align-items:center;position:relative}
.mall-order-refund-refuse-money-reason-default-in-img {max-width:45%;max-height:45%}
.mall-order-refund-refuse-money-reason-vouchimg {display:inline-block;width:80px;height:80px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.3);margin:0 10px 10px 0;border-radius:6px;}
.mall-order-refund-refuse-money-reason-vouchimg-in {float:left;width:100%;height:80px;display:flex;justify-content:center;align-items:center;position:relative}
.mall-order-refund-refuse-money-reason-vouchimg-close {position:absolute;right:0;top:0;width:20px;height:20px;margin:-10px -10px 0 0;cursor:pointer}
.mall-order-refund-refuse-money-reason-vouchimg-close-img {float:left;width:20px;height:20px;}
.mall-order-refund-refuse-money-reason-vouchimg-in-img {max-width:75%;max-height:75%;border-radius:6px}

.mall-order-refund-address-to-buyer {display:inline-block;width:100%}
.mall-order-refund-address-to-buyer-infos {float:left;width:calc(100% - 40px);padding:20px 10px;background:#F2F6FC;border-radius:6px;margin-bottom:10px}
.mall-order-refund-address-to-buyer-infos-left {float:left;width:10%;height:50px;display:flex;align-items:center}
.mall-order-refund-address-to-buyer-infos-button {cursor:pointer}
.mall-order-refund-address-to-buyer-infos-button img {width:25px;height:25px}
.mall-order-refund-address-to-buyer-infos-content {float:left;width:75%;height:50px;display:flex;align-items:center}
.mall-order-refund-address-to-buyer-infos-content-in {float:left;width:100%}
.mall-order-refund-address-to-buyer-infos-name {float:left;width:100%;font-size:13px;line-height:23px;text-align:right}
.mall-order-refund-address-to-buyer-infos-name i {font-style:normal;margin-left:10px;font-size:13px;color:#999999}
.mall-order-refund-address-to-buyer-infos-city {float:left;width:100%;font-size:13px;line-height:23px;text-align:right}
.mall-order-refund-address-to-buyer-infos-address {float:left;width:100%;font-size:13px;line-height:23px;text-align:right}
.mall-order-refund-address-to-buyer-infos-right {float:left;width:15%;height:50px;display:flex;justify-content:center;align-items:center}
.mall-order-refund-address-to-buyer-infos-button {cursor:pointer}
.mall-order-refund-address-to-buyer-infos-button img {width:20px;height:20px}
.mall-order-refund-address-to-buyer-infos-button-del {cursor:pointer}
.mall-order-refund-address-to-buyer-infos-button-del img {width:20px;height:20px;margin-left:5px}

.mall-order-sale-before-status {float:left;margin-right:3%;font-size:12px;line-height:18px;background:#fff;border:1px solid #dcdfe6;border-radius:6px;padding:2px 10px}
.mall-order-refund-msg-more-result-out {display:inline-block;width:100%}
.mall-order-refund-msg-more-result {float:left;width:calc(100% - 4% - 2px );padding:5px 2%;display:flex;align-items:center;background:rgba(221,221,221,.3);border:1px solid rgba(221,221,221,.7);border-radius:6px;margin-bottom:10px}
.mall-order-refund-msg-more-result img {width:20px;height:20px;border-radius:50%}
.mall-order-refund-msg-more-result-content {float:left;font-size:13px;margin-left:10px}
</style>



// WEBPACK FOOTER //
// src/components/mall/OrderAfter.vue